import { createAsyncThunk } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../app/funcs/orderResultToast";
import { getFAQList, registerFAQ, RegisterFAQRequestType, updateFAQ, deleteFAQ } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/FAQ",
    getList: "getList",
    register: "register",
    update: "update",
    delete: "delete"
});

export const getFAQListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async (_, { rejectWithValue }) => {
        const response = await getFAQList();

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const registerFAQAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.register}`,
    async (data: {
        requestData: RegisterFAQRequestType
    }, { rejectWithValue }) => {
        const response = await registerFAQ(data.requestData);

        if (response.error === undefined) {
            orderSuccessToast("FAQを登録しました");
            return {};
        } else {
            // API処理結果異常の場合
            orderErrorToast("FAQの登録に失敗しました");
            return rejectWithValue({});
        }
    }
);

export const updateFAQAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.update}`,
    async (data: {
        faqId: string,
        requestData: RegisterFAQRequestType
    }, { rejectWithValue }) => {
        const response = await updateFAQ(data.faqId, data.requestData);

        if (response.error === undefined) {
            orderSuccessToast("FAQを更新しました");
            return {};
        } else {
            // API処理結果異常の場合
            orderErrorToast("FAQの更新に失敗しました");
            return rejectWithValue({});
        }
    }
);

export const deleteFAQAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.delete}`,
    async (data: {
        faqId: string
    }, { rejectWithValue }) => {
        const response = await deleteFAQ(data.faqId);

        if (response.error === undefined) {
            orderSuccessToast("FAQを削除しました");
            return { deletedFAQId: data.faqId };
        } else {
            // API処理結果異常の場合
            orderErrorToast("FAQの削除に失敗しました");
            return rejectWithValue({});
        }
    }

);